import CountUp from "react-countup";
import React, { useEffect, useState } from "react";
import { BaseUrl } from "../../helper/BaseUrl";
import { fetchJson } from "../../helper/fetchJson";
export default function HomeCounter() {

  const [allData, setAllData] = useState();

  const aifetcher = async () => {
    try {
      const result = await fetchJson(`${BaseUrl}/api/stat/edit`);
      setAllData(result.stat);
    } catch (error) {
      console.error('Fetch error:', error.message);
    }
  };

  useEffect(() => {
    aifetcher();
  }, [])


  const data = {
    title: "Designed to scale seamlessly",
    counters: [
      { value: parseFloat(allData?.title1), suffix: allData?.title1.replace(/[0-9.]/g, ""), label: allData?.value1 },
      { value: parseFloat(allData?.title2), suffix: allData?.title2.replace(/[0-9.]/g, ""), label: allData?.value2 },
      { value: parseFloat(allData?.title3), suffix: allData?.title3.replace(/[0-9.]/g, ""), label: allData?.value3 },
      { value: parseFloat(allData?.title4), suffix: allData?.title4.replace(/[0-9.]/g, ""), label: allData?.value4 },
    ],
  };

  return (
    <section className="home-counter">
      <div className="container">
        {data?.title && (
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-8">
              <div className="heading-text heading-gap">
                <h3 className="heading heading-center">{data.title}</h3>
              </div>
            </div>
          </div>
        )}

        <div className="row">
          {data?.counters?.map((item, index) => (
            <div key={index} className={`col-6 col-md-6 col-lg-3 ${index === data.counters.length - 1 ? "last-counter" : ""}`}  >
              <div className="counter-text">
                <div className="heading">
                  {item.prefix && <>{item.prefix}</>}
                  <span className="stat-number">
                    <CountUp start={0} end={item.value} />
                  </span>
                  {item.suffix && <>{item.suffix}</>}
                </div>
                <p>{item.label}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
